<template>
    <el-select class="ele-select"  filterable :clearable="clearable"  @change="change" :size="size" v-model="data" :placeholder="placeholder">
        <el-option
                v-for="item in list"
                :key="item.packageTypeCode"
                :label="item.packageName"
                :value="item.packageTypeCode">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: "package-order",
        props:{
            size:String,
            placeholder:String,
            clearable:Boolean,
            value:[Array,Object,String],
            type:String//是对象还是字符串
        },
        model:{
            prop:'value',
            event:'input'
        },
        data(){
            return{
                list:[],
                data:null,
            }
        },
        watch:{
            value(newval,oldval){
                this.data=this.value;
            }
        },
        mounted(){
            this.getData();
            this.data=this.value;
        },
        methods:{
            getData(){
                this.$axios.get("/foodPackage/foodPackageListGeneralByStoreId/"+this.$root.getStorage('storeId')).then(res => {
                    console.log('普通套餐类型',res)
                    this.list = res.data.list;

                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            change(value){
                var data= this.list.filter((item)=>item.packageTypeCode==value);
                this.$emit('change',data[0]);
                this.$emit('input',value)
            }
        }
    }
</script>

<style scoped>

</style>